export default "__VITE_ASSET__de3e7edb__"